import { BaseModel } from './base.model';
import { Offer } from './offer.model';
import { Unit } from './unit.model';
import { FileModel } from './file.model';

export interface ContractNoteMessage {
  id: string;
  text: string;
  createdAt: string;
  createdBy: number;
  authorName: string;
}

/** File record as embedded within a Contract API response. */
export interface ContractFile {
  id: number;
  contractId: number;
  fileId: number;
  role: string;
  createdBy: number;
  updatedBy: number;
  createdAt: string;
  updatedAt: string;
}

export class Contract extends BaseModel {
  static STATUS_DRAFT = 'draft';
  static STATUS_SENT = 'sent';
  static STATUS_SIGNED = 'signed';
  static STATUS_TERMINATED = 'terminated';

  static STATUS_SEQUENCE = [
    Contract.STATUS_DRAFT,
    Contract.STATUS_SENT,
    Contract.STATUS_SIGNED,
    Contract.STATUS_TERMINATED,
  ];

  id?: number;
  offerId?: number;
  unitId?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
  signedAt?: string | null;
  terminatedAt?: string | null;
  notes?: {messages: ContractNoteMessage[]};
  createdAt?: string;

  offer?: Offer;
  unit?: Unit;
  files?: FileModel[];
  contractFiles?: ContractFile[];

  get childModels() {
    return {
      files: FileModel,
      offer: Offer,
      unit: Unit,
    };
  }

}
